import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/pro-light-svg-icons";
import { usCurrency } from "../../utils";
import { useDeepEffect } from "../../abstracts";
import moment from "moment";

const PayrollTreeStructure = ({
  data,
  isForfeiture,
  setIsForfeiture,
  isACHDebit,
  setIsACHDebit,
  bankTotal,
  forfeitureTotal,
  retriggerCount,
  setRetriggerCount,
}) => {
  const [showBank, setShowBank] = useState(false);
  const [showForfeiture, setShowForfeiture] = useState(false);
  const [showAch, setShowAch] = useState(false);

  return (
    <ul className="Payrolltree">
      {!isEmpty(data.bankFundings) && (
        <li>
          <div className="d-flex justify-content-start">
            <div className="ft-14" style={{ width: "80%", color: "#307bf6" }}>
              <i
                className={
                  showBank ? "far fa-minus-square" : "far fa-plus-square"
                }
                onClick={() => {
                  setShowBank(!showBank);
                }}
              />
              Funding Via Bank
            </div>
            <div className="ft-14 fw-500" style={{ width: "15%" }}>
              {usCurrency(bankTotal)}
            </div>
            <FontAwesomeIcon
              icon={faCheck}
              size="md"
              color="green"
              style={{ width: "5%", marginTop: "8px" }}
              className="pointer"
            />
          </div>
          {showBank && (
            <>
              <ul>
                {data.bankFundings.map((bank) => {
                  return (
                    <li className="d-flex justify-content-start">
                      <div className="ft-12 ml-4" style={{ width: "80%" }}>
                        {bank.bankName}
                      </div>
                      <div className="ft-12" style={{ width: "20%" }}>
                        {usCurrency(bank.bankFund)}
                      </div>
                    </li>
                  );
                })}
              </ul>
              {get(data.bankFundings, "0.fundingStatus") === 3 && (
                <>
                  <span className="ft-12 mr-1 border-right green-text pr-1">
                    Fund received
                  </span>
                  <FontAwesomeIcon
                    icon={faClock}
                    size="xs"
                    style={{ marginTop: "5px" }}
                    className="pointer"
                  />
                  <span className="ml-1 ft-12">
                    {moment(
                      get(data.bankFundings, "0.fundReceivedDate")
                    ).format("DD MMM YY, HH:mm")}
                  </span>
                </>
              )}
            </>
          )}
        </li>
      )}
      {!isEmpty(data.forfeitureFundings) && (
        <li>
          <div className="d-flex justify-content-start">
            <div className="ft-14" style={{ width: "80%", color: "#307bf6" }}>
              <i
                className={
                  showForfeiture ? "far fa-minus-square" : "far fa-plus-square"
                }
                onClick={() => {
                  setShowForfeiture(!showForfeiture);
                }}
              />
              Funding Via Forfeiture
            </div>
            <div className="ft-14 fw-500" style={{ width: "15%" }}>
              {usCurrency(forfeitureTotal)}
            </div>
            {get(data.forfeitureFundings, "0.fundingStatus") === 3 ? (
              <FontAwesomeIcon
                icon={faCheck}
                size="md"
                color="green"
                style={{ width: "5%", marginTop: "8px" }}
                className="pointer"
              />
            ) : (
              <Form.Check
                name={"isForfeiture"}
                type="checkbox"
                label=""
                id={"isForfeiture"}
                className="d-flex justify-content-center mt-1"
                checked={isForfeiture}
                style={{ width: "5%" }}
                onChange={() => setIsForfeiture(!isForfeiture)}
              />
            )}
          </div>
          {showForfeiture && (
            <>
              <ul>
                {data.forfeitureFundings.map((forfeiture) => {
                  return (
                    <li className="d-flex justify-content-start">
                      <div className="ft-12 ml-4" style={{ width: "80%" }}>
                        {forfeiture.forfeitureName}
                      </div>
                      <div className="ft-12" style={{ width: "20%" }}>
                        {usCurrency(forfeiture.forfeitureFund)}
                      </div>
                    </li>
                  );
                })}
              </ul>
              {get(data.forfeitureFundings, "0.fundingStatus") === 3 && (
                <>
                  <span className="ft-12 mr-1 border-right green-text pr-1">
                    Fund received
                  </span>
                  <FontAwesomeIcon
                    icon={faClock}
                    size="xs"
                    style={{ marginTop: "5px" }}
                    className="pointer"
                  />
                  <span className="ml-1 ft-12">
                    {moment(
                      get(data.forfeitureFundings, "0.fundReceivedDate")
                    ).format("DD MMM YY, HH:mm")}
                  </span>
                </>
              )}
            </>
          )}
        </li>
      )}
      {!isEmpty(data.achDebitFundings) && (
        <li>
          <div className="d-flex justify-content-start">
            <div className="ft-14" style={{ width: "80%", color: "#307bf6" }}>
              <i
                className={
                  showAch ? "far fa-minus-square" : "far fa-plus-square"
                }
                onClick={() => {
                  setShowAch(!showAch);
                }}
              />
              Funding Via ACH Debit
            </div>
            <div className="ft-14 fw-500" style={{ width: "15%" }}>
              {usCurrency(get(data, "achDebitFundings[0].amount", 0))}
            </div>
            {get(data.achDebitFundings, "0.fundingStatus") === 3 ? (
              <FontAwesomeIcon
                icon={faCheck}
                size="md"
                color="green"
                style={{ width: "5%", marginTop: "8px" }}
                className="pointer"
              />
            ) : (
              <Form.Check
                name={"isACHDebit"}
                type="checkbox"
                label=""
                id={"isACHDebit"}
                className="d-flex justify-content-center mt-1"
                checked={isACHDebit}
                style={{ width: "5%" }}
                onChange={() => setIsACHDebit(!isACHDebit)}
              />
            )}
          </div>
          {showAch && (
            <>
              <ul>
                {data.achDebitFundings.map((ach) => {
                  return (
                    <li className="d-flex justify-content-start">
                      <div className="ft-12 ml-4" style={{ width: "80%" }}>
                        {ach.bankName}
                      </div>
                      <div className="ft-12" style={{ width: "20%" }}>
                        {usCurrency(ach.amount)}
                      </div>
                    </li>
                  );
                })}
              </ul>
              {retriggerCount >= 1 && (
                <>
                  <span className="ft-12 mr-1 border-right green-text pr-1">
                    Funding retriggered
                  </span>
                  <FontAwesomeIcon
                    icon={faClock}
                    size="xs"
                    style={{ marginTop: "5px" }}
                    className="pointer"
                  />
                  <span className="ml-1 ft-12">
                    {moment(
                      get(data.achDebitFundings, "0.fundReceivedDate")
                    ).format("DD MMM YY, HH:mm")}
                  </span>
                </>
              )}
            </>
          )}
        </li>
      )}
    </ul>
  );
};

export default PayrollTreeStructure;
